// extracted by mini-css-extract-plugin
export default {"cart_section":"favorites_cart_section__oPZeA","cart":"favorites_cart__Bwys1","search":"favorites_search__j4dgo","search_block":"favorites_search_block__9EO9T"};